module.exports = __webpack_public_path__ + "49c5d30c06dd0a2a2b307f600b95742d.svg";